$(document).on(
  "pubgm_mainsite_event_list rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    // $("#blockNews.news").each(function () {
    //   var postsTag = "#" + $(this).attr("id");

    //   $().vPortal({
    //     container: postsTag,
    //     el: {
    //       tabContainer: "#blockNews.news_tab > ul",
    //       resultContainer: ".news_list",
    //     },
    //     paginationOptions: {},
    //   });
    // });
    // Hàm thay video trong #player
// function loadVideo(videoUrl) {
// 	const embedUrl = videoUrl.replace("youtu.be/", "www.youtube.com/embed/");
// 	const iframe = `<iframe width="100%" height="100%" src="${embedUrl}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;
// 	$("#player").html(iframe);
// }

// // Khởi tạo Swiper
// const videoSwiper = new Swiper(".video-list", {
// 	slidesPerView: 2,
// 	spaceBetween: 20,
// 	centeredSlides: true, // <-- Quan trọng!
// 	loop: true,
// 	navigation: {
// 		nextEl: ".next_video",
// 		prevEl: ".prev_video"
// 	},
// 	on: {
// 		init: function () {
// 			const videoUrl = $(this.slides[this.activeIndex]).attr("data-vid");
// 			loadVideo(videoUrl);
// 			$(this.slides).removeClass("active");
// 			$(this.slides[this.activeIndex]).addClass("active");
// 		},
// 		slideChange: function () {
// 			const videoUrl = $(this.slides[this.activeIndex]).attr("data-vid");
// 			loadVideo(videoUrl);
// 			$(this.slides).removeClass("active");
// 			$(this.slides[this.activeIndex]).addClass("active");
// 		}
// 	}
// });


// // Thêm click vào từng slide để đổi video theo ý người dùng (tùy chọn)
// $(".video-list").on("click", ".swiper-slide", function () {
// 	const index = $(this).index();
// 	videoSwiper.slideTo(index);
// });
let videoSwiper;

function initVideoSwiper() {
    if ($(window).width() < 768 && !videoSwiper) {
        videoSwiper = new Swiper(".video-list", {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next.next_video',
                prevEl: '.swiper-button-prev.prev_video',
            },
            on: {
                slideChange: function () {
                    const activeSlide = this.slides[this.activeIndex];
                    const url = $(activeSlide).data("vid");
                    const id = url.match(/(?:youtu\.be\/|v=)([^&]+)/)[1];

                    $("#player").html(`
                        <iframe width="100%" height="100%" 
                                src="https://www.youtube.com/embed/${id}?rel=0" 
                                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
                        </iframe>
                    `);
                    

                    $(".images").removeClass("active");
                    $(activeSlide).addClass("active");
                }
            }
        });
    }
}

    $(document).ready(function () {
        // Khởi tạo video đầu tiên
        $(".images").on("click", function () {
            const url = $(this).data("vid");
            const id = url.match(/(?:youtu\.be\/|v=)([^&]+)/)[1];
            $("#player").html(`
                <iframe width="100%" height="100%" 
                        src="https://www.youtube.com/embed/${id}?rel=0" 
                        frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
                </iframe>
            `);
            
            $(".images").removeClass("active");
            $(this).addClass("active");
        });

        $(".images").first().trigger("click"); // Load video đầu tiên mặc định

        initVideoSwiper(); // Khởi chạy swiper nếu là mobile

        $(window).on('resize', function () {
            if ($(window).width() < 768 && !videoSwiper) {
                initVideoSwiper();
            }
        });
    });
  }
);
